// extracted by mini-css-extract-plugin
export default {"timelineGroup":"timelineGroup--xqDSp","photoShaft":"photoShaft--DM0AO","photo":"photo--nAt6u","timelineGroupItem":"timelineGroupItem--qApAH","singleton":"singleton--GntNv"};